export default __webpack_public_path__ + "static/media/karimkhan.12853435.jpg";